import * as moment from "moment";
import * as React from "react";
import * as Modal from "react-modal";
import { Link } from "react-router-dom";
import * as Constants from "../../core/constants";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IStatusChangePostLog from "../../types/IStatusChangePostLog";

interface IPostbackLogDetailModalProps extends ITranslationProps {
    isOpen: boolean;
    onRequestClose: () => void;
    log: IStatusChangePostLog | null;
}

function PostbackLogDetailModal(p: IPostbackLogDetailModalProps) {
    return (
        <Modal isOpen={p.isOpen}
            onRequestClose={p.onRequestClose}
            style={{
                content: {
                    position: "relative",
                    top: "auto",
                    bottom: "auto",
                    left: "auto",
                    right: "auto",
                    maxWidth: "1200px",
                    margin: "1.75rem auto",
                    padding: "10px"
                },
                overlay: {
                    zIndex: 10
                }
            }}>
            <div className="modal-header">
                <h5 className="modal-title"> {p.t("PostbackLogList.Details")}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={p.onRequestClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body postbacklog-detail">

                {p.log &&
                    <div className="row">
                        <div className="col-md-3"><strong>{p.t("MessageList.ReferenceID")}</strong></div>
                        <div className="col-md-9">{p.log.referenceID}</div>

                        <div className="col-md-3"><strong>{p.t("MessageDetail.UniqueID")}</strong></div>
                        <div className="col-md-9">{p.log.uniqueID}</div>

                        <div className="col-md-3"><strong>{p.t("Global.Date")}</strong></div>
                        <div className="col-md-9">{moment(p.log.dateTimeCreated).format(Constants.MOMENT_FORMAT_DATETIME)}</div>

                        <div className="col-md-3"><strong>{p.t("PostbackLogList.Action")}</strong></div>
                        <div className="col-md-9">{p.log.action}</div>

                        <div className="col-md-3"><strong>{p.t("MessageList.MessageType")}</strong></div>
                        <div className="col-md-9">{p.log.messageType}</div>

                        <div className="col-md-3"><strong>{p.t("PostbackLogList.PostbackUrl")}</strong></div>
                        <div className="col-md-9">{p.log.statusChangePostURL}</div>

                        <div className="col-md-3"><strong>{p.t("Global.Error")}</strong></div>
                        <div className="col-md-9">{p.log.error}</div>

                        <div className="col-md-3"><strong>{p.t("PostbackLogList.Message")}</strong></div>
                        <div className="col-md-9"><pre>{p.log.message ? JSON.stringify(JSON.parse(p.log.message), null, 2) : ""}</pre></div>

                        <div className="col-md-12">
                            <Link to={`/message/${p.log.messageHeaderID}/${p.log.messageType}`}>{p.t("SendMessage.ViewMessage")}</Link>
                        </div>
                    </div>
                }
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-id="postbacklog-modal" data-dismiss="modal" onClick={p.onRequestClose}>{p.t("Global.Close")}</button>
            </div>
        </Modal>

    );
}

export default translateComponent(PostbackLogDetailModal);



// WEBPACK FOOTER //
// ./src/components/PostbackLogList/PostbackLogDetailModal.tsx